export const CHOSEN_BUSINESS = "CHOSEN_BUSINESS";
export const ACTION_CHOSEN_BUSINESS = "ACTION_CHOSEN_BUSINESS";
export const STORE_SUPPORTED_CURRENCIES = "STORE_SUPPORTED_CURRENCIES";
export const ACTION_STORE_SUPPORTED_CURRENCIES = "ACTION_STORE_SUPPORTED_CURRENCIES";
export const TOGGLE_SIDEBAR = "TOGGLE_SIDEBAR";
export const ACTION_TOGGLE_SIDEBAR = "ACTION_TOGGLE_SIDEBAR";
export const UNALLOCATED = "UNALLOCATED";
export const ACTION_REDIRECT_BUSINESS = "ACTION_REDIRECT_BUSINESS";
